import React, { useState } from 'react';
import { ChevronDownOutline } from "@carbon/icons-react";
import { ChevronsDown, ChevronsUp } from 'react-feather';

const Legend = (data) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleCollapse = () => {
        console.log('Toggle Collapse'); // Debugging line
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className="rounded bg-slate-100 h-fit absolute ml-8 mb-8 bottom-0 z-[10000] w-fit p-2">
            <button onClick={toggleCollapse} className="legend-toggle">
                {isCollapsed ? (<><div className='flex items-center'><ChevronsUp /> <p className='text-base capitalize'> show</p></div></>) : (<><div className='flex items-center'><ChevronsDown /> <p className='text-base capitalize'> Hide</p></div></>)}
            </button>
            {!isCollapsed && (
                <>
                    {data?.data?.length > 0 && data?.data?.map((item, index) => {
                        return (
                            <div className="legend-item-1 flex" key={index}>
                                <div className="legend-color my-auto items-center">
                                    <img className="h-5" src={item.img} alt={`${item.title}`} />
                                </div>
                                <div className="legend-label col-span-4 p-1 font-semibold text-sm ml-3">{item.title}</div>
                            </div>
                        );
                    })}
                    <div className="legend-item-1 flex">
                        <div className="legend-color items-center">
                            <span className="w-3 block mt-2 mr-1 h-3 rounded-full bg-red-400"></span>
                        </div>
                        <div className="legend-label col-span-4 p-1 font-semibold text-sm ml-4">Red Zones</div>
                    </div>

                    <div className="legend-item-1 flex">
                        <div className="legend-color items-center">
                            <span className="w-3 block mt-2 mr-1 h-3 rounded-full bg-yellow-400"></span>
                        </div>
                        <div className="legend-label col-span-4 p-1 font-bold text-sm ml-4">Yellow Zones</div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Legend;
